import { HelixIcon } from '@components/icon/icon';
import RenderIf from '@components/utility/renderIf';
import EmbarkLogo from '@generated/icons/EmbarkLogo';
import { Avatar, AvatarProps } from '@mui/material';
import { FC } from 'react';

type HelixAvatarProps = AvatarProps;

const HelixAvatar: FC<HelixAvatarProps> = ({ ...props }) => {
  const { children } = props;
  return (
    <Avatar {...props}>
      <RenderIf condition={!children}>
        <HelixIcon rem={1.5}>
          <EmbarkLogo />
        </HelixIcon>
      </RenderIf>
      {children}
    </Avatar>
  );
};

export { HelixAvatar as default, HelixAvatar };
export type { HelixAvatarProps };
